import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InitializeService } from './initialize.service';
import { InitializeAware } from './initialize-aware';
import { EmployeeService } from '../employee/logic/employee.service';
import { ServicejobsService } from '../servicejobs/logic/servicejobs.service';
import { ActivityTypesService } from '../activity-types/logic/activity-types.service';
import { AppParameterService } from '../app-parameter/logic/app-parameter.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { ArchivesService } from '../archives/logic/archives.service';
import { BadgesService } from '../badges/logic/badges.service';
import { BillOfQuantitiesService } from '../bill-of-quantities/logic/bill-of-quantities.service';
import { BillOfQuantitiesPositionsService } from '../bill-of-quantities-positions/logic/bill-of-quantities-positions.service';
import { BranchTypesService } from '../branch-types/logic/branch-types.service';
import { BranchesService } from '../branches/logic/branches.service';
import { CargoItemsService } from '../cargo-item/logic/cargo-item.service';
import { CargoItemTypesService } from '../cargo-item-types/logic/cargo-item-types.service';
import { CarsService } from '../cars/logic/cars.service';
import { CredentialsService } from '../credentials/logic/credentials.service';
import { DynFormsService } from '../dyn-forms/logic/dyn-forms.service';
import { EmpJobMappingsService } from '../emp-job-mapping/logic/emp-job-mapping.service';
import { EquipmentsService } from '../equipments/logic/equipments.service';
import { ExtFilesService } from '../ext-files/logic/ext-files.service';
import { ActivityConfirmationsService } from '../activity-confirmations/logic/activity-confirmations.service';
import { ProjectContactDirectoryService } from '../project-contact-directory/logic/project-contact-directory.service';
import { DeficiencyTicketWatchersService } from '../deficiency-ticket-watchers/logic/deficiency-ticket-watchers.service';
import { PersonsService } from '../persons/logic/persons.service';
import { BranchFunctionGroupsService } from '../branch-function-groups/logic/branch-function-groups.service';
import { EmployeeFunctionGroupsService } from '../employee-function-groups/logic/employee-function-groups.service';
import { CellphonesService } from '../cellphones/logic/cellphones.service';
import { FunctionGroupsService } from '../function-group/logic/function-groups.service';
import { JobSectionsService } from '../job-section/logic/job-section.service';
import { MaskDefinitionService } from '../mask-definition/logic/mask-definition.service';
import { MaterialsService } from '../materials/logic/materials.service';
import { MenuService } from '../menu/logic/menu.service';
import { RemoteActionService } from '../remote-action/logic/remote-action.service';
import { OrderItemsService } from '../order-item/logic/order-item.service';
import { PinsService } from '../pins/logic/pins.service';
import { PinTypesService } from '../pin-types/logic/pin-types.service';
import { ProcessStepsService } from '../process-steps/logic/process-steps.service';
import { ReasonsService } from '../reasons/logic/reasons.service';
import { StockService } from '../stock/logic/stock.service';
import { TourService } from '../tour/logic/tour.service';
import { TourStopsService } from '../tour-stop/logic/tour-stop.service';
import { WorktypesService } from '../worktypes/logic/worktypes.service';
import { TagTemplatesElementsService } from '../tag-templates-elements/logic/tag-templates-elements.service';
import { SyncService } from '../sync/sync.service';
import { PreferencesService } from '../preferences/preferences.service';
import { DeficiencyTicketsService } from '../deficiency-ticket/logic/deficiency-tickets.service';
import { PeripheralsService } from '../peripherals/logic/peripherals.service';
import { RequiredUserActionsService } from '../required-user-actions/logic/required-user-actions.service';
import { TranslationsService } from '../translations/logic/translations.service';
import { GPSTrackService } from '../gps-track/gps-track.service';
import { MaterialDemandInfosService } from '../materialdemandinfo/logic/materialdemandinfos.service';
import { AccessibilityService } from '../accessibility/accessibility.service';
import { AppTasksService } from '../app-tasks/logic/app-tasks.service';
import { ObjectIdLabelService } from '../object-id-label/logic/object-id-label.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: InitializeAware,
      useExisting: EmployeeService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: ServicejobsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: ActivityTypesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: AppParameterService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: ActivityTypesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: ArchivesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: BadgesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: BillOfQuantitiesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: BillOfQuantitiesPositionsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: BranchTypesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: BranchesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: CargoItemsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: CargoItemTypesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: CarsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: CredentialsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: DynFormsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: EmpJobMappingsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: EquipmentsService,
      multi: true,
    },
    // ActivityConfirmations before ExtFiles, the ExtFile draft handling builds
    // on the AC infos
    {
      provide: InitializeAware,
      useExisting: ActivityConfirmationsService,
      multi: true,
    },
    // These synced services were missing here, so a `reinit` never reloaded
    // their local data and appStatus$ did not wait for it.
    // ClientStateService is deliberately NOT registered.
    {
      provide: InitializeAware,
      useExisting: ProjectContactDirectoryService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: DeficiencyTicketWatchersService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: PersonsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: BranchFunctionGroupsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: EmployeeFunctionGroupsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: CellphonesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: FunctionGroupsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: ExtFilesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: JobSectionsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: MaskDefinitionService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: MaterialsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: MenuService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: OrderItemsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: PinTypesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: PinsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: DeficiencyTicketsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: ProcessStepsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: ReasonsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: RemoteActionService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: StockService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: TourService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: TourStopsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: WorktypesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: TagTemplatesElementsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: SyncService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: PreferencesService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: PeripheralsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: RequiredUserActionsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: TranslationsService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: GPSTrackService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: MaterialDemandInfosService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: AccessibilityService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: AppTasksService,
      multi: true,
    },
    {
      provide: InitializeAware,
      useExisting: ObjectIdLabelService,
      multi: true,
    },
    InitializeService,
  ],
})
export class InitializeModule {}
